module.exports = __webpack_public_path__ + "static/media/close.932607a8.svg";